export { default } from './CondoLandingHero';
